import { render, staticRenderFns } from "./ProjectAudit.vue?vue&type=template&id=2b91f628&"
import script from "./ProjectAudit.vue?vue&type=script&lang=js&"
export * from "./ProjectAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports